import SimpleTable from './SimpleTable';
import SimpleTableHelpers from './utils/helper';

export { SimpleTable as default, SimpleTable, SimpleTableHelpers };
